var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":_vm.url,"alt":"banner"}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-desc"},[_c('h1',[_vm._v("上海趋致信息科技")]),_c('p',[_vm._v("创新与卓越的融合，积极探索创新模式")]),_c('p',[_vm._v("凭借着专业的团队和丰富的经验")]),_c('p',[_vm._v("在科技信息领域成为众多企业信赖的合作伙伴")])])
}]

export { render, staticRenderFns }